import { listEnumNumbers } from "@protobuf-ts/runtime"
import { useMemo } from "react"

import { UseEnumFilterProps, UseEnumFilterRes } from "./types/useFilter.types"

export function useEnumFilter({
  enumeration,
  labelExtractor,
  ...otherProps
}: UseEnumFilterProps): UseEnumFilterRes {
  const { useFilter, ...restProps } = otherProps

  const values = useMemo<number[]>(() => {
    return listEnumNumbers(enumeration)
      .filter(Boolean)
      .sort((a, b) => labelExtractor(a).localeCompare(labelExtractor(b)))
  }, [enumeration, labelExtractor])

  const res = useFilter({
    keyExtractor,
    values,
    labelExtractor,
    ...restProps,
  })

  const selected = useMemo<number[]>(() => {
    return res.selectedKeys.map((key) => Number(key))
  }, [res.selectedKeys])

  return {
    ...res,
    selected,
  }
}

function keyExtractor(value: number) {
  return value.toString()
}
